import React from 'react';
import PropTypes from 'prop-types';
import RulesOperations from './comp/rulesOperations/RulesOperationsConnector';
import './manageRulesPage.scss';
import RuleEditorContainer from './comp/ruleEditorContainer/RuleEditorConnector';

class ManageRulesPage extends React.Component {
  componentWillMount() {
    document.title = 'Manage Transformation Rules';
  }

  render(){
    return (
      <div className="manage-rules__page react-page">
        <h1>Manage Transformation Rules</h1>
        <hr />
        <RuleEditorContainer />
        <RulesOperations />
      </div>
    );
  }
}

ManageRulesPage.propTypes = {
  history: PropTypes.shape().isRequired
};

export default ManageRulesPage;



// WEBPACK FOOTER //
// ./src/components/manageRules/ManageRulesPage.js